import { IBeneficiaries } from "./models";

export const ownershipOptions = [
  { id: "1", label: "Todos" },
  { id: "2", label: "Titular" },
  { id: "3", label: "Dependentes" },
];

export const beneficiaryItems: IBeneficiaries[] = [
  {
    id: "1",
    ownership: ownershipOptions[0].label,
  },
  {
    id: "2",
    ownership: ownershipOptions[1].label,
  },
  {
    id: "3",
    ownership: ownershipOptions[2].label,
  },
];
